import {clientGetWrapper} from "../api/Api"
import {GET_ALL_CATEGORIES} from "../common/constants/routes";


export const getAllCategories = () => {
    return clientGetWrapper(GET_ALL_CATEGORIES);
}


